import React from 'react'
import Search from '.'
import { useTranslation } from 'react-i18next'

interface Props {
  productId: string
  version: string
  language: string
}

export default function ModuleSearch(props: Props) {
  const { productId, version, language } = props
  const { t } = useTranslation()

  const options = {
    filters: `product:${productId} AND version:${version} AND language:${language}`,
  }

  return (
    <Search
      modalTitle={`${t('search.label')} ${t(
        `contentPackage.${productId}.name`
      )} v${version}`}
      options={options}
      hideProductText
    />
  )
}
